import { ClientModel } from '../models/client.model';

export const clientNameTemplate = (client: ClientModel): string => {
  return `${client.commercialName ?? ''}${
    client.legalName ? ' (' + client.legalName + ')' : ''
  }`;
};
